import React from 'react'

export default () => (
  <svg viewBox="0 0 12 12" fill="none">
    <path d="M6.75 1H5.5V2.66667H6.75V1Z" fill="#AD0021"/>
    <path d="M6.75 3.5H5.5V11H6.75V3.5Z" fill="#AD0021"/>
  </svg>
)
